import { EventEmitter } from "@angular/core";
import { environment } from "@env/environment";
import * as i0 from "@angular/core";
import * as i1 from "@angular/common/http";
import * as i2 from "./comments.service";
import * as i3 from "./auth.service";
export class ProjectService {
    constructor(http, commentService, authService) {
        this.http = http;
        this.commentService = commentService;
        this.authService = authService;
    }
    static setTemplate(template) {
        try {
            localStorage.setItem("template", JSON.stringify(template));
            ProjectService.templateAplied.emit();
        }
        catch (err) {
            console.error("Error saving to localStorage", err);
        }
    }
    static getTemplate() {
        try {
            return JSON.parse(localStorage.getItem("template"));
        }
        catch (err) {
            console.error("Error getting data from localStorage", err);
            return null;
        }
    }
    static set text_structure_cycles(text_structure_cycles) {
        try {
            localStorage.setItem("text_structure_cycles", JSON.stringify(text_structure_cycles));
        }
        catch (err) {
            console.error("Error saving to localStorage", err);
        }
    }
    static get text_structure_cycle() {
        try {
            return JSON.parse(localStorage.getItem("text_structure_cycles"));
        }
        catch (err) {
            console.error("Error getting data from localStorage", err);
            return null;
        }
    }
    storeCycleStructure(formData) {
        return this.http.post(`${environment.base_url}/projects/cycles`, formData);
    }
    updateCycleStructure(formData, id) {
        return this.http.put(`${environment.base_url}/projects/cycles/${id}`, formData);
    }
    setNavbarPercentage() {
        ProjectService.percentageChanged.emit();
    }
    calcPercentage(cycles) {
        const MAX_PERCENTAGE = 33.33;
        let sumWeightCycle1 = 0;
        let sumWeightCycle2 = 0;
        let sumWeightCycle3 = 0;
        let sumWeightDefineCycle1 = 0;
        let sumWeightDefineCycle2 = 0;
        let sumWeightDefineCycle3 = 0;
        for (let cycle in cycles) {
            for (let step in cycles[cycle]) {
                const status = cycles[cycle][step].status;
                const weight = Number(cycles[cycle][step].weight);
                if (cycle === "1") {
                    if (status !== "discard") {
                        sumWeightCycle1 += weight;
                        if (status === "define") {
                            sumWeightDefineCycle1 += weight;
                        }
                    }
                }
                else if (cycle === "2") {
                    if (status !== "discard") {
                        sumWeightCycle2 += weight;
                        if (status === "define") {
                            sumWeightDefineCycle2 += weight;
                        }
                    }
                }
                else if (cycle === "3") {
                    if (status !== "discard") {
                        sumWeightCycle3 = weight;
                        if (status === "define") {
                            sumWeightDefineCycle3 += weight;
                        }
                    }
                }
            }
        }
        const cycle1Constant = sumWeightCycle1
            ? MAX_PERCENTAGE / sumWeightCycle1
            : 0;
        const cycle2Constant = sumWeightCycle2
            ? MAX_PERCENTAGE / sumWeightCycle2
            : 0;
        const cycle3Constant = sumWeightCycle3
            ? MAX_PERCENTAGE / sumWeightCycle3
            : 0;
        const cycle1Progress = cycle1Constant * sumWeightDefineCycle1;
        const cycle2Progress = cycle2Constant * sumWeightDefineCycle2;
        const cycle3Progress = cycle3Constant * sumWeightDefineCycle3;
        return Math.round(cycle1Progress + cycle2Progress + cycle3Progress);
    }
    setEnterProject(value) {
        this.enterProject = value;
    }
    getEnterProject() {
        return this.enterProject;
    }
    setName(name) {
        try {
            localStorage.setItem("nameProject", name);
        }
        catch (err) {
            console.error("Error in set nameProject");
        }
    }
    getName() {
        try {
            const name = localStorage.getItem("nameProject");
            return name;
        }
        catch (err) {
            console.error(err);
        }
        return null;
    }
    setAuthor(name) {
        try {
            localStorage.setItem("projectAuthor", name);
        }
        catch (err) {
            console.error("Error in set projectAuthor");
        }
    }
    getAuthor() {
        try {
            const author = localStorage.getItem("projectAuthor");
            return author;
        }
        catch (err) {
            console.error(err);
        }
    }
    setReferenceType(name) {
        try {
            localStorage.setItem("referenceType", name);
        }
        catch (err) {
            console.error("Error in set referenceType");
        }
    }
    getReferenceType() {
        try {
            const name = localStorage.getItem("referenceType");
            return name;
        }
        catch (err) {
            console.error(err);
        }
        return null;
    }
    removeReferenceType() {
        localStorage.removeItem("referenceType");
    }
    paginate(per_page = 20, page = 1, param = "") {
        return this.http.get(`${environment.base_url}/projects?page=${page}&per_page=${per_page}&param=${param}`);
    }
    paginateStudentsProjects(per_page = 20, page = 1, param = "") {
        return this.http.get(`${environment.base_url}/projects/my_student_projects?page=${page}&per_page=${per_page}&param=${param}`);
    }
    store(form, repositoryId = null) {
        return this.http.post(`${environment.base_url}/projects`, Object.assign({}, form, { repository_id: repositoryId }));
    }
    update(id, form) {
        return this.http.put(`${environment.base_url}/projects/${id}`, form);
    }
    updateReferenceType(id, form) {
        return this.http.put(`${environment.base_url}/projects/${id}/update_reference_type`, form);
    }
    historical(id) {
        return this.http.get(`${environment.base_url}/projects/${id}/historical`);
    }
    invitation(projectId, invitation) {
        return this.http.post(`${environment.base_url}/projects/${projectId}/invitations`, invitation);
    }
    settings(id) {
        return this.http.get(`${environment.base_url}/projects/${id}/settings`);
    }
    settingsStructureGeneral(id, settings) {
        return this.http.post(`${environment.base_url}/projects/${id}/settings/structure/general`, settings);
    }
    settingsStructureFonts(id, settings) {
        return this.http.post(`${environment.base_url}/projects/${id}/settings/structure/fonts`, settings);
    }
    settingsStructureCapas(id, settings) {
        return this.http.post(`${environment.base_url}/projects/${id}/settings/structure/capas`, settings);
    }
    settingsStructureIllustration(id, settings) {
        return this.http.post(`${environment.base_url}/projects/${id}/settings/structure/illustration`, settings);
    }
    settingsStructurePretextual(id, settings) {
        return this.http.post(`${environment.base_url}/projects/${id}/settings/structure/pretextual`, settings);
    }
    settingsStructurePostextual(id, settings) {
        return this.http.post(`${environment.base_url}/projects/${id}/settings/structure/postextual`, settings);
    }
    uninvite(projectId, selectedAuthorsIds, repositoryId = null) {
        return this.http.put(`${environment.base_url}/projects/${projectId}/uninvite${repositoryId ? `/${repositoryId}` : ""}`, selectedAuthorsIds);
    }
    getInvitationRole(projectId) {
        return this.http.get(`${environment.base_url}/projects/${projectId}/get_invitation_role`);
    }
    updateProgress(projectId, data) {
        return this.http.put(`${environment.base_url}/projects/${projectId}/update_progress`, data);
    }
    getCycles(projectId) {
        return this.http.get(`${environment.base_url}/projects/${projectId}/get_cycles`);
    }
    getCycle(projectId, cycle) {
        return this.http.get(`${environment.base_url}/projects/${projectId}/get_cycle/${cycle}`);
    }
    delete(formData) {
        return this.http.post(`${environment.base_url}/projects/delete`, formData);
    }
    myProjectsCount() {
        return this.http.get(`${environment.base_url}/projects/my_projects_count`);
    }
    myProjectsOrientedCount() {
        return this.http.get(`${environment.base_url}/projects/my_projects_oriented_count`);
    }
    clone(id) {
        return this.http.get(`${environment.base_url}/projects/${id}/clone`);
    }
    incrementAccess(projectId) {
        return this.http.get(`${environment.base_url}/projects/${projectId}/increment_access`);
    }
    getProjectWhithoutRepository(isAuthor = true) {
        return this.http.get(`${environment.base_url}/projects/get_projects_without_repositories?is_author=${isAuthor}`);
    }
    userHasAccess(projectId) {
        return this.http.get(`${environment.base_url}/projects/${projectId}/user_has_access`);
    }
    setOpenProject(project) {
        const template = project.template;
        const participants = [];
        console.log('project', project);
        if (project.advisor) {
            const advisor = project.advisor;
            participants.push({
                id: advisor.id,
                name: advisor.name,
                role: "advisor",
            });
        }
        if (project.cosupervisor) {
            const cosupervisor = project.cosupervisor;
            participants.push({
                id: cosupervisor.id,
                name: cosupervisor.name,
                role: "co-supervisor",
            });
        }
        if (project.mentors.length) {
            const mentors = project.mentors;
            participants.push(...mentors.map((mentor) => ({
                id: mentor.id,
                name: mentor.name,
                role: "mentor",
            })));
        }
        const coauthors = project.authors
            .filter((author) => !author.author_principal)
            .map((a) => ({
            id: a.id,
            name: a.name,
            blind_selection: a.blind_selection,
            role: "author",
        }));
        participants.push(...coauthors);
        this.authService.setParticipants(participants);
        const mainAuthor = project.authors.find((a) => a.author_principal);
        if (mainAuthor.name === this.authService.user.name) {
            this.authService.setInvitationRole("main_author");
        }
        else {
            this.getInvitationRole(project.id).subscribe((invitationRole) => {
                this.authService.setInvitationRole(invitationRole);
                const user = this.authService.user;
                const coauthor = coauthors.find((a) => a.name === user.name);
                if (coauthor && coauthor.blind_selection) {
                    this.authService.setBlindSelection("yes");
                }
                else {
                    this.authService.setBlindSelection("no");
                }
            });
        }
        ProjectService.setTemplate(template);
        this.commentService.getCountMessage(project.id);
        this.setEnterProject(true);
        this.setName(project.title);
        this.setAuthor(mainAuthor.name);
        this.setReferenceType(project.reference_type);
        ProjectService.text_structure_cycles = project.text_structure_cycles;
        this.incrementAccess(project.id).subscribe(() => { });
    }
}
ProjectService.templateAplied = new EventEmitter();
ProjectService.percentageChanged = new EventEmitter();
ProjectService.ngInjectableDef = i0.ɵɵdefineInjectable({ factory: function ProjectService_Factory() { return new ProjectService(i0.ɵɵinject(i1.HttpClient), i0.ɵɵinject(i2.CommentService), i0.ɵɵinject(i3.AuthService)); }, token: ProjectService, providedIn: "root" });
